/**
 * While a business is onboarding, an in-progress Sales Name Check makes the
 * server refuse with 409 SALES_NAME_CHECK_IN_PROGRESS (spec D6, §10.2) —
 * POST /auth/finalize-onboarding included. Read with raw fetch, that answer
 * must stop the caller: finishing onboarding anyway would show "setup
 * complete" while the server still says the business is not onboarded.
 *
 * Returns the message to show for that refusal, or null for any other answer
 * (which keeps its existing handling).
 */
const SALES_NAME_CHECK_IN_PROGRESS = 'SALES_NAME_CHECK_IN_PROGRESS';
const STANDARD_MESSAGE = 'Sales Name Check is in progress — finish it or set it aside first.';

export const salesNameCheckRefusal = (status, body) => {
  if (status !== 409 || !body || body.code !== SALES_NAME_CHECK_IN_PROGRESS) return null;
  return typeof body.error === 'string' && body.error.trim() ? body.error : STANDARD_MESSAGE;
};
